// extracted by mini-css-extract-plugin
export default {"scc__thankyou__img":"ThankYou_scc__thankyou__img__kcNs4","scc__thankyou__container":"ThankYou_scc__thankyou__container__N9fIz"};